let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d2eTj")).then(() => parcelRequire('fYw7A'));